<div class="ion-page modal-body">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">
      <h4 class="t-h4 mt-4 t-medium">{{'MODALS.RESET-PASSWORD.TITLE' | translate}}</h4>
      <!-- <form class="text-left mt-4"> -->
        <p>
          {{'MODALS.RESET-PASSWORD.DESCRIPTION' | translate}}
        </p>

        <form form [formGroup]="resetForm" class="text-left mt-4">
          <div class="mb-3">
            <label for="reset_email" class="form-label">{{ 'MODALS.LOGIN.EMAIL' | translate }}</label>
            <input type="email" id="reset_email" [(ngModel)]="resetEmail" formControlName="email" class="form-control"
              placeholder="{{'PLACEHOLDERS.EMAIL' | translate}}" required />
            <span class="text-danger error " *ngIf="errorControl.email.errors?.required">
                {{'FORM_ERR.EMAIL_REQ' | translate}} 
            </span>
            <span class="text-danger error " *ngIf="errorControl.email.errors?.pattern">
                {{'FORM_ERR.EMAIL_INV' | translate}}
            </span>
          </div>
        </form>
        
        <button [disabled]="errorControl.email.errors"  (click)="onClick_reset()" class="btn btn-primary btn-block">{{'COMMON.RESET' | translate}}</button>
      <!-- </form> -->
    </div>
    <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>
